import { Typography } from '@material-ui/core'
import React from 'react'
import { useBestPracticeAuditHistory } from '../hooks/useBestPracticeAuditHistory'
import { useBestPracticeManagementPanelStyles } from '../styles/useBestPracticeManagementPanelStyles'
import { BestPracticeTipCard } from './BestPracticeTipCard'
import { BestPracticeTipCardSkeleton } from './BestPracticeTipCardSkeleton'

const SKELETON_COUNT = 3

const STATUS_MESSAGES = {
    ERROR: 'Failed to load Best Practice activity. Please try again.',
    WAITING: 'Select a section version to see its Best Practice activity.',
    EMPTY: 'No Best Practice activity yet for this section.',
}

export const BestPracticeTipsList = () => {
    const classes = useBestPracticeManagementPanelStyles()
    const { tips, loading, error, waitingForIteration } =
        useBestPracticeAuditHistory()

    if (loading) {
        return (
            <div data-testid="bestPracticeTipsListLoading">
                {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
                    <BestPracticeTipCardSkeleton key={`skeleton-${i}`} />
                ))}
            </div>
        )
    }

    const statusMessage = error
        ? STATUS_MESSAGES.ERROR
        : waitingForIteration
        ? STATUS_MESSAGES.WAITING
        : tips.length === 0
        ? STATUS_MESSAGES.EMPTY
        : null

    if (statusMessage) {
        return (
            <Typography className={classes.headerText}>
                {statusMessage}
            </Typography>
        )
    }

    return (
        <div data-testid="bestPracticeTipsList">
            {tips.map((tip) => (
                <BestPracticeTipCard key={tip.id} tip={tip} />
            ))}
        </div>
    )
}
